import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DiscoveryLabPage from './DiscoveryLabPage';
import DiscoveryJobDetailPage from './DiscoveryJobDetailPage';
import ValidationPage from './ValidationPage';
import BacktestPage from './BacktestPage';
import BacktestResultPage from './BacktestResultPage';
import MonitoringPage from './MonitoringPage';
import UniverseBrowser from './UniverseBrowser';
import AuditPage from './AuditPage';
import WorkerStatusPill from './components/WorkerStatusPill';

const SUB_TABS = [
  { path: '/trading/quant', label: 'Discovery Lab', end: true },
  { path: '/trading/quant/backtest', label: 'Backtest' },
  { path: '/trading/quant/monitoring', label: 'Live Monitor' },
  { path: '/trading/quant/universe', label: 'Universe' },
  { path: '/trading/quant/audit', label: 'Audit' },
];

const QuantLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname.replace(/\/$/, '') || '/trading/quant';

  // Detail pages — match patterns like /trading/quant/jobs/<uuid>
  const isDiscoveryJobDetail = /^\/trading\/quant\/jobs\/[^/]+$/.test(currentPath);
  const isValidation = /^\/trading\/quant\/validation\/[^/]+$/.test(currentPath);
  const isBacktestResult = /^\/trading\/quant\/backtest\/[^/]+$/.test(currentPath);

  // Find the active top-level sub-tab
  const findActive = () => {
    if (isDiscoveryJobDetail || currentPath === '/trading/quant') return SUB_TABS[0];
    if (isBacktestResult || currentPath.startsWith('/trading/quant/backtest')) return SUB_TABS[1];
    if (isValidation || currentPath.startsWith('/trading/quant/validation')) return SUB_TABS[0];
    if (currentPath.startsWith('/trading/quant/monitoring')) return SUB_TABS[2];
    if (currentPath.startsWith('/trading/quant/universe')) return SUB_TABS[3];
    if (currentPath.startsWith('/trading/quant/audit')) return SUB_TABS[4];
    return SUB_TABS[0];
  };
  const activeTab = findActive();

  const [mounted, setMounted] = useState(() => ({ [activeTab.path]: true }));

  const handleTabClick = (path) => {
    setMounted(prev => ({ ...prev, [path]: true }));
    navigate(path);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <nav className="flex overflow-x-auto gap-1">
          {SUB_TABS.map(tab => {
            const isActive = activeTab.path === tab.path;
            return (
              <button
                key={tab.path}
                onClick={() => handleTabClick(tab.path)}
                className={`px-3 py-1.5 text-xs uppercase tracking-wider whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-b-2 border-brand-gold text-brand-gold'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
        <WorkerStatusPill />
      </div>

      {/* Detail pages take precedence over main sub-tabs (deep links) */}
      {isDiscoveryJobDetail && <DiscoveryJobDetailPage />}
      {isValidation && <ValidationPage />}
      {isBacktestResult && <BacktestResultPage />}

      {/* Main sub-tabs — display:none preserves state */}
      {!isDiscoveryJobDetail && !isValidation && !isBacktestResult && (
        <>
          <div style={{ display: currentPath === '/trading/quant' ? 'block' : 'none' }}>
            {mounted['/trading/quant'] && <DiscoveryLabPage />}
          </div>
          <div style={{ display: currentPath === '/trading/quant/backtest' ? 'block' : 'none' }}>
            {mounted['/trading/quant/backtest'] && <BacktestPage />}
          </div>
          <div style={{ display: currentPath.startsWith('/trading/quant/monitoring') ? 'block' : 'none' }}>
            {mounted['/trading/quant/monitoring'] && <MonitoringPage />}
          </div>
          <div style={{ display: currentPath.startsWith('/trading/quant/universe') ? 'block' : 'none' }}>
            {mounted['/trading/quant/universe'] && <UniverseBrowser />}
          </div>
          <div style={{ display: currentPath.startsWith('/trading/quant/audit') ? 'block' : 'none' }}>
            {mounted['/trading/quant/audit'] && <AuditPage />}
          </div>
        </>
      )}
    </div>
  );
};

export default QuantLayout;
